import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestion = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.17647 14.2353C8.11765 14.2353 7.29412 15.0588 7.29412 16.1176C7.29412 17.1765 8.06471 18 9.17647 18C10.1824 18 11.0588 17.1765 11.0588 16.1176C11.0588 15.0588 10.1824 14.2353 9.17647 14.2353ZM11.1235 2H8.11765C5.82353 2 4 3.82353 4 6.11765C4 6.88235 4.64706 7.52941 5.41176 7.52941C6.17647 7.52941 6.82353 6.88235 6.82353 6.11765C6.82353 5.41176 7.35882 4.82353 8.06471 4.82353H11.0706C11.8294 4.82353 12.4706 5.41176 12.4706 6.11765C12.4706 6.58824 12.2353 6.94706 11.8235 7.18235L8.47059 9.23529C8 9.52941 7.76471 10 7.76471 10.4706V11.4118C7.76471 12.1765 8.41176 12.8235 9.17647 12.8235C9.94118 12.8235 10.5882 12.1765 10.5882 11.4118V11.2941L13.2412 9.64706C14.4765 8.88235 15.2412 7.52941 15.2412 6.11765C15.2941 3.82353 13.4706 2 11.1235 2Z",
		fill: "#0D2976"
	})
});
export default SvgQuestion;
